import React, { useMemo } from "react";
import { Spin } from "antd";
import { map } from "lodash";
import { FindingDetailsGrid } from "./FindingDetailsGrid";
import { PermissionSetMap } from "constants/RBACConstants";
import { useFindingDetails } from "./FindingDetailsProvider";
import { canEditCustomField, getCustomFieldFormatter } from "../utils";
import { hasPermission, isSuperOrTenantAdmin } from "utils/authService";

export function MoreInformation() {
  const { loading, finding, findingCustomFields, openCustomFindingFieldEditPopup } = useFindingDetails();

  const customFieldsList = useMemo(() => {

    if (!findingCustomFields) return [];

    const hasEditPermission = isSuperOrTenantAdmin() || hasPermission(PermissionSetMap.EDIT_CUSTOM_FIELDS);

    return map(findingCustomFields, (customField) => {
      const isFieldEditable = canEditCustomField(customField);

      return {
        label: customField.label,
        path: customField.id,
        disableEdit: () => !hasEditPermission || !isFieldEditable,
        editButtonToolTip: !hasEditPermission ? 'No access' : 'Due to a data type conversion, this custom field is currently uneditable. For any modifications, please refer to Global Settings',
        formatter: getCustomFieldFormatter(customField, 350),
        containerClassName: "flex-column",
        span: 24,
        valueBold: false,
        editAction: () => openCustomFindingFieldEditPopup(customField),
      };
    });
  }, [findingCustomFields, openCustomFindingFieldEditPopup]);

  return (
    <div className="finding-description-section">
      <Spin spinning={loading}>
        <FindingDetailsGrid
          list={customFieldsList}
          data={finding}
          itemGapClassName="m-b-m"
        />
      </Spin>
    </div>
  );
}

export default MoreInformation;
